import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title: string;
    description: string;
    keywords: string;
    image?: string;
    url: string;
    type?: string;
}

const SEOHead: React.FC<SEOProps> = ({
    title,
    description,
    keywords,
    image = '%PUBLIC_URL%/logo512.png',
    url,
    type = 'website'
}) => {
    useEffect(() => {
        // Fallback for dynamic meta tags
        document.title = title;
    }, [title]);

    return (
        <Helmet prioritizeSeoTags>
            {/* Basic metadata */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />

            {/* JSON-LD structured data */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": type,
                    "name": title,
                    "description": description,
                    "image": image,
                    "url": url
                })}
            </script>
        </Helmet>
    );
};

export default SEOHead; 